import { createFileRoute } from "@tanstack/react-router";
import { PortalDomainsV2Page } from "@/components/v2/pages/portal-domains-v2-page";

export const Route = createFileRoute("/portal/domains/")({
  component: PortalDomainsV2Page,
});
